// extracted by mini-css-extract-plugin
export default {"container":"showFile_container__KsSOR","main":"showFile_main__WKgwR","img":"showFile_img__p1Zuy","deleteIconContainer":"showFile_deleteIconContainer__bPjBz"};